/*eslint-disable */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'dva';
import { InputItem } from 'antd-mobile';
import { fixedBody, looseBody } from '@/utils/fn';
import { openPageNative } from '@/utils/bridge';
import { debounce } from '@/utils/utils';
import NoData from '../../components/NoData';
import styles from '../../styles/bonus.less';

const UseBounsCardModal = ({
  rights: { bonusDeviceList },
  onClose,
  handleBindDevice,
  queryDeviceList,
}) => {
  const listRef = useRef(null);

  const handleCloseModal = useCallback(() => {
    onClose();
  }, []);

  const handleAddNewDevice = useCallback(() => {
    openPageNative({ url: 'page:qr_scan?origin=0' });
  }, []);

  const debounceInputChange = debounce(val => {
    listRef.current?.scrollTo(0, 0);
    queryDeviceList(val);
  }, 800);

  useEffect(() => {
    fixedBody();
    return () => {
      // queryDeviceList('');
      looseBody();
    };
  }, []);

  return (
    <div className={styles.modalMask} onClick={handleCloseModal}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>
          选择加成设备
          <i className={styles.close} onClick={handleCloseModal} />
        </h3>
        <div className={styles.searchBar}>
          <InputItem clear placeholder="可搜索设备名称/分组/类型" onChange={debounceInputChange} />
        </div>
        {bonusDeviceList?.length > 0 ? (
          <ul className={styles.deviceList} ref={listRef}>
            {bonusDeviceList.map((device, index) => (
              <li key={index} className={styles.deviceItem}>
                <div className={styles.deviceInfo}>
                  <h4 className={styles.note}>{device.remark}</h4>
                  <p className={styles.deviceText}>设备SN：{device.sn}</p>
                  <p className={styles.deviceText}>
                    <span className={styles.group}>{device.groupName || '未知'}</span>
                    <span className={styles.type}>{device.deviceType || '未知'}</span>
                  </p>
                </div>
                <button className={styles.bindBtn} onClick={() => handleBindDevice(device)}>
                  使用
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <NoData
            text={
              <p>
                您没有满足条件设备可使用，
                <br />
                快点击下方添加新设备吧！
              </p>
            }
          />
        )}
        <div className={styles.modalFooter}>
          <button className={styles.addBtn} onClick={handleAddNewDevice}>
            添加新设备
          </button>
        </div>
      </div>
    </div>
  );
};
export default connect(({ rights, loading }) => ({
  rights,
  loading: loading.effects['rights/getBounsDeviceList'],
}))(UseBounsCardModal);
